import { Controller } from "@hotwired/stimulus"
import jstz from 'jstz'

export default class extends Controller {
  connect() {
    this.element.value = this.findTimeZone();
  }

  findTimeZone() {
    const oldIntl = window.Intl
    try {
      window.Intl = undefined
      const tz = jstz.determine().name()
      window.Intl = oldIntl
      return tz
    } catch (e) {
      // sometimes (on android) you can't override intl
      return jstz.determine().name()
    }
  }
}

